import { ModalInfoOkComponent } from './../../../shared/components/modals/info-ok/modal-info-ok.component';
import { ModalAddSocieteComponent } from './../../../shared/components/modals/modal-add-societe/modal-add-societe.component';
import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacyPaginator as MatPaginator, LegacyPageEvent as PageEvent } from '@angular/material/legacy-paginator';
import { Sort } from '@angular/material/sort';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ReferentielDTO } from 'src/app/shared/dtos/referentielDTO';
import { SimpleQueryResponse } from 'src/app/shared/dtos/simpleQueryResponse';
import { SimpleQueryUser } from 'src/app/shared/dtos/simpleQueryUser';
import { SocieteModel } from 'src/app/shared/models/simple-types/societe.model';
import { SocieteService } from 'src/app/shared/services/simple/societe.service';
import { GestionReferentielComponentService } from '../gestion-referentiel-component.service';
import { ActiviteModel } from 'src/app/shared/models/simple-types/activite.model';
import { ActiviteService } from 'src/app/shared/services/simple/activite.service';

@Component({
  selector: 'app-gestion-societe',
  templateUrl: './gestion-societe.component.html',
  styleUrls: ['./gestion-societe.component.scss']
})
export class GestionSocieteComponent implements OnInit {

  societes: SocieteModel[] = [];
  displayedColumns: string[] = ['code', 'libelle', 'capitalSocial', 'rsc', 'siren', 'tvaIntraComm', 'activite', 'action'];
  dataSource: SocieteModel[];
  matDataSource = new MatTableDataSource<SocieteModel>();
  sortState: Sort = {active: 'code', direction: 'desc'};
  length: number;
  pageSize = 25;
  pageEvent: PageEvent;
  activites: ActiviteModel[] = [];
  result: boolean;
  objet: SimpleQueryUser = new SimpleQueryUser();

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  // tslint:disable-next-line: no-output-on-prefix
  @Output() onUpdated = new EventEmitter<boolean>();

  constructor(
    public router: Router,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private toastrService: ToastrService,
    private societeService: SocieteService,
    private activiteService: ActiviteService,
    private gestionReferentielComponent: GestionReferentielComponentService
  ) { }

  ngOnInit(): void {
    this.objet.query = '';
    this.objet.pageNumber = 0;
    this.objet.pageSize = this.pageSize;
    this.objet.order = 'code';
    this.matDataSource.paginator = this.paginator;
    this.loadPage();
    // getAll Activites
    this.activiteService.getAll().subscribe(types => {
      this.activites = types;
    });
  }

  onCreate(): void {
    const form = this.gestionReferentielComponent.getCreateSocieteFormGroup();
    const dialogRef = this.dialog.open(ModalAddSocieteComponent, {
        autoFocus: false,
        disableClose: true,
        data: {
          form,
          societes: this.societes,
          activites: this.activites,
          result: this.result
        }
      });

    dialogRef.afterClosed().subscribe(result => {
        this.onUpdated.emit(true);
        if (result) {
         this.loadPage();
        }
      });

  }

  onModify(societe: SocieteModel): void {
    const form = this.gestionReferentielComponent.getEditSocieteFormGroup(societe);
    const dialogRef = this.dialog.open(ModalAddSocieteComponent, {
        autoFocus: false,
        disableClose: true,
        data: {
          form,
          societes: this.societes,
          activites: this.activites,
          result: this.result
        }
      });

    dialogRef.afterClosed().subscribe(result => {
        this.onUpdated.emit(true);
        if (result) {
         this.loadPage();
        }
      });
  }


  onDelete(societe: SocieteModel): void {
    const dialogRef = this.dialog.open(ModalInfoOkComponent, {
      data: {
        title: 'désactivation de la société',
        message: 'Êtes-vous sur de vouloir désactiver la société ?',
        icone: 'warning_amber',
        iconColor: 'accent',
        color: 'accent'
      }
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.societeService.desactivation(societe.id, societe).subscribe((response: SocieteModel) => {
          this.toastrService.success('La société a bien été désactivé');
          this.loadPage();
        });
      }
    });
  }


  orderUsers(societes: SocieteModel[]): SocieteModel[] {
    societes = societes.sort((a, b) => {
      if (a.libelle) {
        return a.libelle.localeCompare(b.libelle);
      } else {
        return -1;
      }
    });
    return societes;
  }

  changePage(event?: PageEvent): void {
    this.objet.pageNumber =  event.pageIndex;
    this.objet.pageSize = event.pageSize;
    this.loadPage();
  }

  search(): void {
    this.objet.pageNumber = 0;
    this.objet.pageSize = this.pageSize;
    this.paginator.pageIndex = 0;
    this.loadPage();
  }

  loadPage(): void {
    const referentiel = new ReferentielDTO();
    referentiel.objet = this.objet;
    this.societeService.loadFromSimpleQueryAdmin(referentiel).subscribe((query: SimpleQueryResponse<SocieteModel>) => {
      if (query.objets != null) {
        this.societes = query.objets;
      } else {
        this.societes = [];
      }
      this.length = query.count;
      this.matDataSource = new MatTableDataSource<SocieteModel>(this.societes);
      this.paginator.length = this.length;
    });
  }

  onLeave(): void {
    this.router.navigate(['/gestion-referentiel']);
  }

  sortData(sort: Sort): void {
    if (sort.direction !== 'asc') {
      this.objet.descending = false;
    } else {
      this.objet.descending = true;
    }
    this.sortState = sort;
    this.objet.order = sort.active;
    this.loadPage();
  }

}
